import { render } from "./login-body.vue?vue&type=template&id=72bad5e0&scoped=true"
import script from "./login-body.vue?vue&type=script&lang=js"
export * from "./login-body.vue?vue&type=script&lang=js"

import "./login-body.vue?vue&type=style&index=0&id=72bad5e0&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bad5e0"]])

export default __exports__